module.exports = __webpack_public_path__ + "img/qualityVerification.eb13bc92.svg";